import React, { useState } from 'react';
import "./UserDelete.css";
import { deleteUser } from "../../../api/admin/adminApi"; // 실제 경로 맞게 수정하세요

const UserDelete = ({ user, setShowDelete }) => {
  const [adminPW, setAdminPW] = useState(""); // 입력한 관리자 비밀번호 상태
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setShowDelete(false);
  };

  const handleDelete = async () => {
    if (!adminPW) {
      alert("관리자 비밀번호를 입력하세요.");
      return;
    }

    if (!user?.id) {
      alert("삭제할 유저가 선택되지 않았습니다.");
      return;
    }

    try {
      setLoading(true);
      const res = await deleteUser(user.id, adminPW);
      alert("유저가 성공적으로 삭제되었습니다.");
      console.log("삭제 응답:", res.data);
      setShowDelete(false); // 모달 닫기
    } catch (error) {
      console.error("유저 삭제 실패:", error);
      alert("유저 삭제에 실패했습니다. 비밀번호를 확인하세요.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='UserDelete_Container'>
      <div className='UserDelete_TitleBox'>
        {user?.name || "선택된"} 사용자 삭제
      </div>

      <div className='UserDelete_NameContainer'>
        <div className='UserDelete_NameBox'>관리자 비밀번호</div>
        <input
          type='password'
          className='UserDelete_NameTextFelid'
          placeholder="관리자 비밀번호를 입력하세요"
          value={adminPW}
          onChange={(e) => setAdminPW(e.target.value)}
        />
      </div>

      <div className='UserDelete_BtnContainer'>
        <div
          className='UserDelete_Btn'
          onClick={loading ? undefined : handleDelete}
          style={{ opacity: loading ? 0.5 : 1 }}
        >
          {loading ? "삭제 중..." : "삭제"}
        </div>
        <div className='UserDelete_Btn' onClick={handleClose}>
          취소
        </div>
      </div>
    </div>
  );
};

export default UserDelete;
